export default "__VITE_ASSET__D6P2W0BL__"